<!-- ./src/components/shared/BreadCrumb.vue -->
<template>
  <div class="breadcrumb-container d-inline-flex float-left mt-2">
    <div class="breadcrumb-real">
      <div class="breadcrumb-left">
        <span v-for="(p, index) in paths" :key="p.path">
          <router-link
            tag="span"
            :to="p.path"
            :class="{ maintitle: !!current || index < paths.length - 1 }"
            class="etichette-white"
          >
            <p class="breadcrumb-link">{{ $t(p.name) }}</p>
          </router-link>
          <img
            src="../../assets/icons/arrow-black.svg"
            class="pr-3"
            v-if="index < paths.length - 1"
            style="margin-top: -2px"
          />
        </span>
      </div>
      <div class="buttons-right">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    current: { type: String },
    mbeTracking: { type: String }
  },
  data() {
    return {
      paths: []
    };
  },
  created() {
    const matched = this.$route.matched;

    for (let i = 0; i < matched.length; i++) {
      const element = matched[i];

      const path = {
        path: element.path,
        name: element.meta.breadcrumb
      };
      const patt = new RegExp(":|/$");
      const res = patt.test(element.path);
      if (!res) {
        this.paths.push(path);
        if (path.name === "new_shipment") {
          path.path = "/shipments/shipments-management";
          this.paths.push({ path: "", name: "new" });
        }
      } else {
        // Take out :id from path
        path.path = path.path.substr(0, path.path.indexOf(":"));
        if (path.name === "edit_shipment") {
          path.path = "/shipments/shipments-management";
        }
        this.paths.push(path);
        if (
          this.paths !== undefined &&
          this.paths !== null &&
          Array.isArray(this.paths) &&
          this.paths.length > 0
        ) {
          if (this.paths[0].name === "Spedizioni") {
            const route = this.$route.fullPath;
            this.paths.push({ path: "", name: this.mbeTracking });
          } else {
            this.paths.push({ path: "", name: "detail" });
          }
        } else {
          this.paths.push({ path: "", name: "detail" });
        }
      }
    }
  }
};
</script>

<style scoped>
.breadcrumb-container {
  width: 100vw;
  background: #282b2c;
  position: fixed;
  top: 50px;
  left: 0;
  display: flex;
  justify-content: center;
  z-index: 2;
}

.breadcrumb-real {
  /* max-width: 1440px; */
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  padding-left: 135px;
  padding-right: 25px;
}

.breadcrumb-left {
  margin-top: 12px;
  font-family: Ubuntu, Verdana, sans-serif;
  font-size: 17px;
}

.breadcrumb-link {
  display: inline-block;
}
</style>
